import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { DarwinComponent } from 'app/modules/darwin/darwin.component';
import { StylesResolver } from '@awin/shared';
import { AuthorizedGuard } from './guards/authorized-guard/authorized.guard';
import { OidcComponent } from './oidc/oidc.component';
import { OidcResolver } from './resolvers/oidc/oidc.resolver';

const routes: Routes = [
  {
    path: 'oidc',
    component: OidcComponent,
    resolve: [OidcResolver],
  },
  {
    path: '',
    pathMatch: 'prefix',
    resolve: [ StylesResolver, OidcResolver ],
    canActivate: [AuthorizedGuard],
    component: DarwinComponent,
    loadChildren: () =>
      import('./modules/communication-centre/communication-centre.module')
        .then(m => m.CommunicationCentreModule),
  },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {
}
